import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReauth} from "./baseQuery";

export const manageOrdersAPI = createApi({
  reducerPath: "manageOrdersAPI",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getExistingOrdertTable: builder.query({
      query: (params) => {
        return {
          url: `api/orders/order/`,
          params,
        };
      },
    }),
    getOrderDetail: builder.query({
      query: (id) => {
        return {
          url: `api/orders/order/${id}/get_order_details/`,
        };
      },
    }),
    updateOrderStatus: builder.mutation({
      query: ({id, params}) => ({
        url: `api/orders/order/${id}/update_suborder_details/`,
        method: "PATCH",
        body: params,
      }),
    }),
    cancelOrderDetails: builder.mutation({
      query: (id) => ({
        url: `api/orders/order/cancel_order/`,
        method: "PATCH",
        body: id,
      }),
    }),
    updateOrderDetailsAddress: builder.mutation({
      query: (params) => ({
        url: `api/orders/order/update_order_address/`,
        method: "PATCH",
        body: params,
      }),
    }),
    addOrderPayment: builder.mutation({    
      query: (paymentData) => ({
        url: "api/orders/order/create_payment_history/",
        method: "POST",
        body: paymentData,
      }),
    }),
    convertToOrderAPI: builder.mutation({
      query: (convertData) => ({
        url: "api/orders/rfq/convert_to_order/",
        method: "POST",
        body: convertData,
      }),
    }),
    getSubOrderDetail: builder.query({
      query: (id) => {
        return {
          url: `api/orders/order/${id}/get_suborder_details/`,
        };
      },
    }),

    getVehiclesDetail: builder.query({
      query: () => {
        return {
          url: `/api/orders/vehicles/`,
        };
      },
    }),
    updateVehiclesDetail: builder.mutation({
      query: (params) => {
        const formData = new FormData();

        formData.append("vehicle_id", params.vehicle_id);
        formData.append("waybillno", params.waybillno);
        formData.append(
          "customer_logistics_ref_no",
          params.customer_logistics_ref_no
        );
        formData.append("assigned_date", params.assigned_date);
        formData.append("assigned_time", params.assigned_time);
        formData.append("driver_name", params.driver_name);
        formData.append("driver_phone_number", params.driver_phone_number);
        formData.append("vechicle_number", params.vechicle_number);
        formData.append("sub_order", params.sub_order);
        formData.append("vehicle", params.vehicle);
        formData.append("transporter_name", params.transporter_name);
        formData.append("transporter_id", params.transporter_id);
        if (params.add_way_bill !== undefined && params.add_way_bill !== '') {
        // formData.append("add_way_bill", params.add_way_bill);
        }
        return {
          url: "api/orders/order/update_suborder_vehicle/",
          method: "PATCH",
          body: formData,
        };
      },
    }),
    addVehicle: builder.mutation({
      query: (params, file) => {
        const isNewLogisticsFlow =
          params?.logistic_channel !== undefined ||
          params?.schedule_option !== undefined ||
          params?.schedule_date_time !== undefined ||
          params?.sub_order_id !== undefined;

        if (isNewLogisticsFlow) {
          return {
            url: "api/orders/order/assign_suborder_vehicle/",
            method: "POST",
            body: params,
          };
        }

        const formData = new FormData();
        if (params.sub_order_id !== undefined && params.sub_order_id !== "") {
          formData.append("sub_order_id", params.sub_order_id);
        }
        if (
          params.logistic_channel !== undefined &&
          params.logistic_channel !== ""
        ) {
          formData.append("logistic_channel", params.logistic_channel);
        }
        if (
          params.pickup_address_id !== undefined &&
          params.pickup_address_id !== ""
        ) {
          formData.append("pickup_address_id", params.pickup_address_id);
        }
        if (
          params.schedule_option !== undefined &&
          params.schedule_option !== ""
        ) {
          formData.append("schedule_option", params.schedule_option);
        }
        if (
          params.schedule_date_time !== undefined &&
          params.schedule_date_time !== ""
        ) {
          formData.append("schedule_date_time", params.schedule_date_time);
        }
        if (Array.isArray(params.vehicles)) {
          formData.append("vehicles", JSON.stringify(params.vehicles));
        }
        if (
          params.delivery_date !== undefined &&
          params.delivery_date !== ""
        ) {
          formData.append("delivery_date", params.delivery_date);
        }
        if (
          params.delivery_slot !== undefined &&
          params.delivery_slot !== ""
        ) {
          formData.append("delivery_slot", params.delivery_slot);
        }
        if (params.waybillno !== undefined && params.waybillno !== "") {
          formData.append("waybillno", params.waybillno);
        }
        if (
          params.customer_logistics_ref_no !== undefined &&
          params.customer_logistics_ref_no !== ""
        ) {
          formData.append(
            "customer_logistics_ref_no",
            params.customer_logistics_ref_no
          );
        }
        if (params.assigned_date !== undefined && params.assigned_date !== '') {
        formData.append("assigned_date", params.assigned_date);
        }
        if (params.assigned_time !== undefined && params.assigned_time !== '') {
        formData.append("assigned_time", params.assigned_time);
        }
        if (params.driver_name !== undefined && params.driver_name !== "") {
          formData.append("driver_name", params.driver_name);
        }
        if (
          params.driver_phone_number !== undefined &&
          params.driver_phone_number !== ""
        ) {
          formData.append("driver_phone_number", params.driver_phone_number);
        }
        if (params.vechicle_number !== undefined && params.vechicle_number !== "") {
          formData.append("vechicle_number", params.vechicle_number);
        }
        if (params.sub_order !== undefined && params.sub_order !== "") {
          formData.append("sub_order", params.sub_order);
        }
        if (params.vehicle !== undefined && params.vehicle !== "") {
          formData.append("vehicle", params.vehicle);
        }
        if (params.add_way_bill !== undefined && params.add_way_bill !== '') {
          formData.append("add_way_bill", params.add_way_bill);
        }
        if (
          params.transporter_name !== undefined &&
          params.transporter_name !== ""
        ) {
          formData.append("transporter_name", params.transporter_name);
        }
        if (params.transporter_id !== undefined && params.transporter_id !== "") {
          formData.append("transporter_id", params.transporter_id);
        }
        
        return {
          url: "api/orders/order/assign_suborder_vehicle/",
          method: "POST",
          body: formData,
        };
      },
    }),
    deleteSuborderVehicle: builder.mutation({
      query: (deleteId) => ({
        url: `api/orders/order/delete_suborder_vehicle/`,
        method: "DELETE",
        body: deleteId,
      }),
    }),
    updateReportingManager : builder.mutation({
      query: (params) => ({
        url: `api/orders/order/update_reporting_manager/`,
        method: "PATCH",
        body: params,
      }),
    }),
    deleteSuborderFile: builder.mutation({
      query: (deleteId) => ({
        url: `api/orders/order/delete_suborder_file/`,
        method: "DELETE",
        body: deleteId,
      }),
    }),
    getVendorAddress: builder.query({
      query: (params) => {
        return {
          url: `accounts/mob_vendor/get_vendor_address/`,
          params,
        };
      },
    }),
    getOrdersListExcel: builder.query({
      query: (params) => {
        return {
          url: `/api/orders/order/download_order_details/`,
          params,
        };
      },
    }),
    getCustProjectList: builder.query({
      query: ({id, params}) => {
        return {
          url: `/accounts/mob_customer/${id}/get_projects/`,
          params,
        };
      },
    }),
    createProject: builder.mutation({
      query: ({id, body}) => {
        console.log("body",body)
        const formdata = new FormData();
        body.project_image !== undefined &&
        formdata.append("project_image", body.project_image);

        body.project_name !== undefined &&
          formdata.append("project_name", body.project_name);
        body.city !== undefined &&
          formdata.append("city", body.city);

          if (body.site_delivery) {           
            formdata.append("site_delivery", body.site_delivery);
          }
          if (body.address) {   
            body.address !== undefined &&       
            formdata.append("address", JSON.stringify(body.address));
            // formdata.append("site_delivery", siteDeliveryInt);
          }
        return {
          method: "POST",
          url: `/accounts/mob_customer/${id}/create_project/`,        
          body: formdata,
        };
      },
    }),
    updateProject: builder.mutation({
      query: ({id, body}) => {
        console.log("body",body)
        const formdata = new FormData();
        body.project_image !== undefined &&
        formdata.append("project_image", body.project_image);

        body.project_name !== undefined &&
          formdata.append("project_name", body.project_name);
        body.city !== undefined &&
          formdata.append("city", body.city);
          body.project_id !== undefined &&
          formdata.append("project_id", body.project_id);

          if (body.site_delivery) {           
            formdata.append("site_delivery", body.site_delivery);
          }
          if (body.address) {   
            body.address !== undefined &&       
            formdata.append("address", JSON.stringify(body.address));
            // formdata.append("site_delivery", siteDeliveryInt);
          }
        return {
          method: "PATCH",
          url: `/accounts/mob_customer/${id}/update_project/`,        
          body: formdata,
        };
      },
    }),

    generateIRN: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/api/orders/order/generate_irn/`,
          body:params,
        };
      },
    }),
  }),
});

export const {
  useLazyGetExistingOrdertTableQuery,
  useLazyGetVendorAddressQuery,
  useLazyGetOrderDetailQuery,
  useLazyGetVehiclesDetailQuery,
  useLazyGetSubOrderDetailQuery,
  useUpdateOrderStatusMutation,
  useUpdateVehiclesDetailMutation,
  useAddOrderPaymentMutation,
  useConvertToOrderAPIMutation,
  useAddVehicleMutation,
  useDeleteSuborderVehicleMutation,
  useDeleteSuborderFileMutation,
  useCancelOrderDetailsMutation,
  useUpdateOrderDetailsAddressMutation,
  useLazyGetOrdersListExcelQuery,
  useUpdateReportingManagerMutation,
  useLazyGetCustProjectListQuery,
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useGenerateIRNMutation

} = manageOrdersAPI;

export default manageOrdersAPI;
